export default {
  'entityName': 'account',
  'pagination': {
    'rowsPerPage': 10,
    'page': 1,
    'sortBy': 'id',
    'descending': true
  },
  'fields': [
    {
      value: 'username',
      text: 'Username',
      'type': 'text',
      'table': {
        'sortable': true,
        'filter': true
      },
      'validators': [
        'required',
      ]
    },
    {
      value: 'email',
      text: 'Email',
      'type': 'text',
      'table': {
        'sortable': true,
        'filter': true
      },
      'validators': [
        'required',
        'email'
        //issue email 200 caratteri
        ,
        'emaillen'
        //issue email 200 caratteri
      ]
    },
    {
      value: 'name',
      text: 'Name',
      'type': 'text',
      'table': {
        'sortable': true,
        'filter': true
      },
      filter: (_item, search) => ([
        { 'name': `%${search}%`},
        { 'surname': `%${search}%`},
      ]),
      render: item => `${item.name} ${item.surname}`,
      validators: ['required']
    },
    {
      value: 'surname',
      text: 'Surname',
      'type': 'text',
      'validators': [
        'required'
      ]
    },
    {
      value: 'role',
      text: 'Role',
      'type': 'list',
      'table': {
        'sortable': true,
        filter: true
      },
      'list': (item, state) => {
        let types = [
          'EMN User',
          'EMN Estimates',
          'Site',
          'Monitor',
          'EMN Client'
        ]
        if (state.user.role === 'Administrator') {
          types.unshift('Administrator')
        }
        return types
      },
      'validators': [
        'required'
      ]
    },
    {
      "value": "site_id",
      "text": "Site",
      title: "name",
      subtitle: item => `${item.city} - ${item.code}`,
      "type": "autocomplete",
      filter: (_item, search) => ({ 'name':[
        { 'site.name': `%${search}%`},
        { 'site.city': `%${search}%`},
        { 'site.code': `%${search}%`}
      ]}),
      "table": {
          "sortable": true,
          filter: true
      },
      deps: ['role'],
      render: item => item.role === 'Site' && `${item.site.city} - ${item.site.name}` || '',
      visible: item => item.role === 'Site',
      'validators': [
        'required'
      ]      
    },
    {
      value: 'protocols',
      reference: 'protocol_has_site',
      id: 'protocol_id',
      text: 'Protocols',
      title: 'protocol.name',
      multiple: true,
      type: 'autocomplete',
      filter: item => ({ site_id: item.site_id }),
      deps: ['role', 'site_id'],
      disable: item => !item.site_id,
      visible: item => item.role === 'Site'
    },
    {
      value: 'status',
      text: 'Status',
      'type': 'list',
      'table': {
        'sortable': true,
        'filter': true
      },
      'list': [
        'Active',
        'Disabled',
        'Canceled'
      ],
      'validators': [
        'required'
      ]
    }
  ],
  actions: [
    'upsert',
    { "value": "emulateUser", "text": "Emulate User", "icon": "mdi-head-sync-outline", "color": "primary", 
      disable: (item) => {
        return item.role === 'Administrator' || item.role === 'EMN Client'
      }
    },    
    {
      value: "monitor",
      text: "Protocols / Sites",
      color: "primary",
      icon: "mdi-hospital-building",
      disable: item => item.role !== 'Monitor'
    },
    'audit', 
  ]
}
